import { useMessage } from "#internal/intl";

import { useCurrencySymbol, useFormat } from "@superweb/intl";

export const useVatRateOptions = () => {
  const message = useMessage();
  const currencySymbol = useCurrencySymbol();
  const { formatPercent, formatDecimal } = useFormat();

  return [
    {
      value: "0",
      label: message({
        id: "4829fe55-06ab-4f7d-8af6-0e2e2e0a0dd9",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (No VAT) title",
        default: "No VAT",
      }),
      description: message({
        id: "d71adf3d-4051-4b42-a5b5-f2e29153c695",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (No VAT) description",
        default: "Annual income up to {currencySymbol}{amount} million",
        values: {
          amount: formatDecimal(20),
          currencySymbol: currencySymbol("RUB"),
        },
      }),
    },
    {
      value: "5",
      label: message({
        id: "433aa60d-c801-42e8-8258-f60905867f12",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 5%) title",
        default: "{percent} VAT",
        values: {
          percent: formatPercent(0.05),
        },
      }),
      description: message({
        id: "ae385175-f69d-4013-b352-e357eddb5c76",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 5%) description",
        default: "Annual income up to {currencySymbol}{amount} million",
        values: {
          amount: formatDecimal(272.5),
          currencySymbol: currencySymbol("RUB"),
        },
      }),
    },
    {
      value: "7",
      label: message({
        id: "482ed5a9-88e0-48e5-b8ae-b038600887b6",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 7%) title",
        default: "{percent} VAT",
        values: {
          percent: formatPercent(0.07),
        },
      }),
      description: message({
        id: "5c193da7-703f-48d4-af9c-acfe81e47728",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 7%) description",
        default: "Annual income up to {currencySymbol}{amount} million",
        values: {
          amount: formatDecimal(490.5),
          currencySymbol: currencySymbol("RUB"),
        },
      }),
    },
    {
      value: "22",
      label: message({
        id: "667af467-22b6-44f7-895d-2289ec092c85",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 22%) title",
        default: "{percent} VAT",
        values: {
          percent: formatPercent(0.22),
        },
      }),
      description: message({
        id: "6f15e455-ad7b-4030-8ac9-c72dd87e54ca",
        context:
          "Drivers. Drivers form. Details group. Vat rate option (VAT 22%) description",
        default: "Annual income over {currencySymbol}{amount} million",
        values: {
          amount: formatDecimal(490.5),
          currencySymbol: currencySymbol("RUB"),
        },
      }),
    },
  ];
};
